var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatStressLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 104,
    viewBox: "0 0 6 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 31",
    d: "M3.5 4.57227L5.88675 -0.427735L0.113249 -0.427734L2.5 4.57227L3.5 4.57227ZM2.5 4.07227L2.50001 136.572L3.50001 136.572L3.5 4.07227L2.5 4.07227Z",
    fill: "#EB4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatStressLine);
export default __webpack_public_path__ + "static/media/Heat_Stress_Line.8e23d5bd5f976dba16f18a4570dd6fff.svg";
export { ForwardRef as ReactComponent };